import { render, staticRenderFns } from "./CompanyVouchers.vue?vue&type=template&id=2fc25c50"
import script from "./CompanyVouchers.vue?vue&type=script&lang=js"
export * from "./CompanyVouchers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports